"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fossato-serralta": {
    "d1018b32": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "skipSearch": false
    }],
    "canne": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a26ed75": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "skipSearch": false
    }],
    "maranise": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67ad6528": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "skipSearch": false
    }],
    "noce": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e949ccc8": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "skipSearch": false
    }],
    "savuci": [{
      "hkey": "5ef97242",
      "slug": "fossato-serralta",
      "name": "Fossato Serralta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;